// extracted by mini-css-extract-plugin
export default {"footer":"g-z","footerContainer":"h-z"};